import { useState, useCallback, useEffect } from 'react';
import { Question } from '../types';
import { questionsService } from '../services/questions';

export function useQuestion() {
  const [question, setQuestion] = useState<Question | null>(null);
  const [isRefreshing, setIsRefreshing] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchRandomQuestion = useCallback(async () => {
    setIsRefreshing(true);
    setError(null);
    try {
      // Réduction du délai minimal à 150ms pour une transition plus rapide
      const [newQuestion] = await Promise.all([
        questionsService.getRandomExcept(question?.id),
        new Promise(resolve => setTimeout(resolve, 150))
      ]);
      setQuestion(newQuestion);
    } catch (error: any) {
      console.error('Error fetching random question:', error);
      setError('Erreur lors du chargement de la question');
    } finally {
      setIsRefreshing(false);
    }
  }, [question?.id]);

  useEffect(() => {
    fetchRandomQuestion();
  }, []);

  return {
    question,
    isRefreshing,
    error,
    fetchRandomQuestion
  };
};